module.exports = __webpack_public_path__ + "img/id.8ca61b70.png";